module.exports = __webpack_public_path__ + "assets/img/32_641_big.ce0e1177.jpg";